import React from 'react';

import {Link} from 'react-router';

import {UserAvatar} from 'app/components/general/avatars';
import {getUserDetailPageURL} from 'app/urls';
import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import type {
  DocTaskReportItemType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<DocTaskReportItemType>;
  enableVersion?: boolean;
  timestampLabel?: string;
  memberLabel?: string;
}

export function RenderActionTimestampDocuments({
  result,
  timestampLabel,
  memberLabel,
}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{timestampLabel ?? gt('Timestamp')}</FixableHeader>
          <FixableHeader>{memberLabel ?? gt('Member')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r['name']}
              </Link>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td>
              <DateText>{r['timestamp']}</DateText>
            </td>
            <td>
              <div className="d-flex align-items-center">
                <UserAvatar user={r['user']} small showCard className="mr-1" />
                <Link to={getUserDetailPageURL(r['user']['id'])}>
                  {r['user']['name']}
                </Link>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
